import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SalesPage from './pages/SalesPage';
import BookingPage from './pages/BookingPage';
import ThankYouPage from './pages/ThankYouPage';
import AdminPage from './pages/AdminPage';
import LanguageBanner from './components/LanguageBanner';
import { Toaster } from './components/ui/toaster';
import { DEFAULT_LANG } from './i18n';

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <LanguageBanner />
        <Routes>
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
          <Route path="/:lang" element={<SalesPage />} />
          <Route path="/:lang/book" element={<BookingPage />} />
          <Route path="/:lang/thank-you" element={<ThankYouPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
